<template>
    <div>
        <span  v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
            <div style="text-align:left;padding:20px;background-color:#ECEFF1;">
               <v-table style="background-color:#ECEFF1;">
                    <tr>

                        <td>
                           <h4 class="text-h5">
                                {{ k }}
                           </h4>
                        </td>
                   </tr>
               </v-table>
            </div>
            <v-tabs
                bg-color="#ECEFF1"
                color="#01579B"
                align-tabs="left"
            >
                <v-tab>
                    <router-link style="text-decoration:none;"
                        :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-gene-details/${k}`
                             }"
                    ><v-btn id="variant-nav-bar-summary" elevation="3" style="padding:0;">
                        <span
                            v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='summary', 'var-nav-bar-btn-default': this.varPage != 'summary' }">
                        Genomics</span>
                     </v-btn>
                    </router-link>
                </v-tab>
                <v-tab>
                    <router-link style="text-decoration:none;"
                        :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-gene-details/${k}/protein`
                             }"
                    ><v-btn id="variant-nav-bar-summary" elevation="3" style="padding:0;">
                        <span
                            v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='protein', 'var-nav-bar-btn-default': this.varPage != 'protein' }">
                            Protein
                        </span>
                     </v-btn>
                    </router-link>
                </v-tab>
                <v-tab>
                    <router-link style="text-decoration:none;"
                        :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-gene-details/${k}/treatments`,
                         }"
                    >
                    <v-btn id="variant-nav-bar-treatments" elevation="3" style="padding:0;">
                         <span
                                 v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='treatments', 'var-nav-bar-btn-default': this.varPage != 'treatments' }"
                         >
                            Treatments
                         </span>
                     </v-btn>
                    </router-link>
                </v-tab>
                <v-tab>
                <router-link style="text-decoration:none;" v-if="'UTA_Adapter' in item"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-gene-details/${ item['UTA_Adapter']['gene_name'] }/transcripts`,
                     }"
                ><v-btn id="variant-nav-bar-transcripts" elevation="3" style="padding:0;">
                 <span
                    v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='transcripts', 'var-nav-bar-btn-default': this.varPage != 'transcripts' }"
                 >
                    Transcripts
                 </span>
                    </v-btn>
                </router-link>
            </v-tab>
            <v-tab>
                <router-link style="text-decoration:none;" v-if="'UTA_Adapter' in item"
                    :to="{ path: `${this.$store.getters.getRouterBaseURL}/show-gene-details/${ item['UTA_Adapter']['gene_name'] }/gene-expression`,
                     }"
                ><v-btn id="variant-nav-bar-gene-expression" elevation="3" style="padding:0;">
                 <span
                    v-bind:class="{ 'var-nav-bar-btn-selected': this.varPage=='gene-expression', 'var-nav-bar-btn-default': this.varPage != 'gene-expression' }"
                 >
                    Gene expression
                 </span>
                    </v-btn>
                </router-link>
            </v-tab>
            </v-tabs>
        </span>
    </div>
</template>
<script>
</script>
<style>
</style>
